<template>
  <p v-if="visible" class="reward-stock-warning">{{ message }}</p>
</template>

<script>
import { isCouponTemplateExhausted, isWixtarTicketExhausted, COUPON_EXHAUSTED_WARNING, WIXTAR_EXHAUSTED_WARNING } from '@/utils/rewardStockWarning.js';

export default {
  name: 'RewardStockWarning',
  props: {
    template: { type: Object, default: null },
    ticket: { type: Object, default: null }
  },
  computed: {
    visible() {
      if (this.ticket) return isWixtarTicketExhausted(this.ticket);
      return isCouponTemplateExhausted(this.template);
    },
    message() {
      return this.ticket ? WIXTAR_EXHAUSTED_WARNING : COUPON_EXHAUSTED_WARNING;
    }
  }
};
</script>

<style scoped>
.reward-stock-warning {
  color: #b45309;
  font-size: 13px;
  margin: 4px 0 0;
}
</style>
